import React from 'react'
import BannerTop from '../../../src/assets/images/BannerContainer.png'
import ProfileTop from '../../../src/assets/images/profilejob.png'
import styles from './eight.module.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPencil } from '@fortawesome/free-solid-svg-icons'

const neweight = () => {
  return (
    <div>
        <div className='container-fluid'>
                <div className='row mb-3'>
                    <div className='col-md-12'>
                        <div className={`${styles['profile-card']}`}>
                    <div className={`${styles['profile-header']}`}>
                        <img src={BannerTop} alt="RK Consultancy" className={`${styles['profile-banner']}`}/>
                    </div>
                    <div className={`${styles['profile-content']} d-flex justify-content-between`}>
                        <div className={`${styles['logo-profile']}`}>
                            <div className={`${styles['profile-logo']}`}>
                                <img src={ProfileTop} alt="RK Logo"/>
                            </div>
                            <h2 className={`${styles['profile-title']} ms-2`}>RK Consultancy</h2>
                        </div>
                        <div className='mt-3'>
                        <a className={`${styles['edit-btn']}`} href='#'><FontAwesomeIcon icon={faPencil}/></a>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
            <div className='row'>
                <div className='col-md-12'>
                    <div className={`${styles['profile-details']} ${styles['mbb-50']}`}>
                        <div className='d-flex align-items-center mb-3 justify-content-between'>
                            <h4 className={`${styles['title-main']}`}>Company Details</h4>
                            <a href='#' className={`${styles['edits-btn']} btn`}><FontAwesomeIcon className='pe-2' icon={faPencil}/>Edit Profile</a>
                        </div>
                        <hr/>
                        <div className="row">
                            <div className='col-md-12'>
                                <ul className={`${styles['com-details']} list-unstyled`}>
                                    <li className="d-flex justify-content-start">
                                        <span className="fw-bold w-25">Company Size:</span>
                                        <span className="text-secondary">10-20</span>
                                    </li>
                                    <li className="d-flex justify-content-start mt-2">
                                        <span className="fw-bold w-25">Founded:</span>
                                        <span className="text-secondary">2020</span>
                                    </li>
                                    <li className="d-flex justify-content-start mt-2">
                                        <span className="fw-bold w-25">Headquarter:</span>
                                        <span className="text-secondary">Bengaluru</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className='d-flex align-items-center mt-3 justify-content-between'>
                            <h4 className={`${styles['title-main']}`}>About Us</h4>
                        </div>
                        <hr/>
                        <div className="row">
                            <div className='col-md-12'>
                                <p className={`${styles['font-fam']}`}>
                                Mindclick Technologies is a software consulting, technology services and outsourcing company. Mindclick Technologies believes only one mantras- Giving competitive software solution to our client surpassing all the expectations of our clients. Mindclick Technologies provide you the services & solutions in all technologies and platform. -Open source technologies -Microsoft technologies -Mobile application development. IOS, android. -Customize software -Web hosting & Domain Registeration -SEO/SMO/PPC Industries we serve:- -E-commerce -Chat bot -Logistic software -mobile app development -Education app development -custom software development -Order track development (FMCG sector)
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default neweight